import React from "react";
import Icon, { type IconComponent } from "@/icons/base";

const ArrowRightIcon: IconComponent = ({ ...props }) => (
  <Icon {...props}>
    <path
      d="m10.2678568 2.20748461 5.5 5.25c.3095243.29545497.3095243.78957835 0 1.08503332l-5.5 5.24999997c-.29962367.2860044-.77436904.2749639-1.06037346-.0246598s-.27496383-.7743691.02465985-1.0603735l4.14485681-3.9574846-12.627.00000127c-.41421356 0-.75-.33578644-.75-.75s.33578644-.75.75-.75l12.627-.00000127-4.14485681-3.95748207c-.27238516-.26000402-.3062719-.67599229-.09530266-.97458944l.07064281-.08578403c.28600442-.29962368.76074979-.31066427 1.06037346-.02465985z"
      fill="currentColor"
    />
  </Icon>
);

export default ArrowRightIcon;
